import { render, staticRenderFns } from "./fcwpTurbo.vue?vue&type=template&id=5ec7c50c&scoped=true&"
import script from "./fcwpTurbo.vue?vue&type=script&lang=js&"
export * from "./fcwpTurbo.vue?vue&type=script&lang=js&"
import style0 from "./fcwpTurbo.vue?vue&type=style&index=0&id=5ec7c50c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ec7c50c",
  null
  
)

export default component.exports